import {
    GetAssistantConversationQuery,
    AssistantConversationMessage,
    Maybe,
} from "../../../../types/generated";

export function updateMessagesCache(
    query: Maybe<GetAssistantConversationQuery>,
    updateMessages: (messages: AssistantConversationMessage[]) => AssistantConversationMessage[],
) {
    if (!query?.getAssistantConversation) return;

    const messages = query?.getAssistantConversation?.messages as Maybe<
        AssistantConversationMessage[]
    >;
    const data = {
        ...query,
        getAssistantConversation: {
            ...query.getAssistantConversation,
            messages: updateMessages(messages ?? []),
        },
    };

    return data;
}
